import { Component, EventEmitter, ElementRef, Input, Output, forwardRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { bbGenerateShortId } from '../../../shared/utils/bbGenerateShortId.util';

export interface BbRadioListOption {
	label?: string;
	value: string;
	icon?: string;
	checked?: boolean;
	imageUrl?: string;
	disabled?: boolean;
	disabledText?: string;
}

export interface RadioListImage {
	label: string;
	value: string | null;
	description?: string;
	// supply an imageUrl or an icon or a bgAspectRatio
	imageUrl?: string;
	bgAspectRatio?: number; // displays a blue rectangle in the bgAspectRatio
	icon?: string;
	iconStyle?: string;
	disabled?: boolean;
	disabledText?: string;
}

type BbRadioListMode = 'default' | 'image';
@Component({
	selector: 'bb-radio-list',
	templateUrl: './bb-radio-list.component.html',
	styleUrls: ['./bb-radio-list.component.scss'],
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BbRadioListComponent),
		multi: true
	}]
})

export class BbRadioListComponent implements ControlValueAccessor, OnInit, OnChanges {
	@Input() options: BbRadioListOption[];
	@Output() change = new EventEmitter<string>();

	@Input() showIcons = true;
	@Input() noWrap = false;
	@Input() growItems = false;
	@Input() textAside = false;
	@Input() valueOnlyModel = false;
	@Input() mode: BbRadioListMode = 'default';
	// mode image options
	@Input() flexGrow = true;
	@Input() maxColumns: number;
	@Input() imageStyle: 'button' | 'tab' = 'button';
	@Input() borderColor = 'transparent';

	selectedOption: BbRadioListOption;
	selectedOptionValue: string;
	el: HTMLElement;
	propagateChange: any;
	flexBaseChild: string;
	id = bbGenerateShortId();

	constructor(private _eref: ElementRef) {
		this.el = this._eref.nativeElement;
	}

	ngOnInit() {
		if (this.maxColumns) {
			// grid has 10px gap
			const perc = Math.floor(100 / this.maxColumns);
			const gapCorrection = 10 - Math.floor(10 / this.maxColumns);
			this.flexBaseChild = `calc(${perc}% - ${gapCorrection}px)`;
		}
	}

	ngOnChanges(changes: SimpleChanges) {
	}

	onRadioChange(value: BbRadioListOption | string) {
		if (typeof value === 'string') {
			this.selectedOption = this.options.find(option => option.value === value);
		} else {
			this.selectedOption = value;
		}

		this.selectedOptionValue = this.selectedOption && this.selectedOption.value !== undefined ? this.selectedOption.value : null;
		this.propagateChange(this.valueOnlyModel ? this.selectedOption.value : this.selectedOption);
	}

	writeValue(modelValue: BbRadioListOption | string) {
		if (typeof modelValue === 'string') {
			this.valueOnlyModel = true;
			this.selectedOption = this.options.find(option => option.value === modelValue);
		} else {
			this.selectedOption = modelValue;
		}
		this.selectedOptionValue = this.selectedOption && this.selectedOption.value !== undefined ? this.selectedOption.value : null;
	}

	registerOnChange(fn: any) {
		this.propagateChange = fn;
	}

	registerOnTouched() {

	}
}
